/**
 * Echappe les caracteres HTML pour eviter les failles XSS lors d'une injection via v-html.
 */
export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/**
 * Retourne une chaine HTML ou chaque occurrence de `search` (case-insensitive) dans `text`
 * est entouree de balises <strong>. Les autres caracteres sont echappes pour eviter le XSS.
 *
 * @param text   Le texte a afficher
 * @param search La sous-chaine a mettre en evidence
 * @returns      HTML safe pour v-html
 */
export function highlightMatch(text: string, search: string): string {
  if (!text) return "";
  if (!search) return escapeHtml(text);

  const lowerText = text.toLowerCase();
  const lowerSearch = search.toLowerCase();
  const searchLen = search.length;

  let result = "";
  let lastIdx = 0;
  let idx = lowerText.indexOf(lowerSearch);

  while (idx !== -1) {
    result += escapeHtml(text.slice(lastIdx, idx));
    result += "<strong>" + escapeHtml(text.slice(idx, idx + searchLen)) + "</strong>";
    lastIdx = idx + searchLen;
    idx = lowerText.indexOf(lowerSearch, lastIdx);
  }
  result += escapeHtml(text.slice(lastIdx));
  return result;
}
